import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {environment} from '@/environments';
import {ApiFeedbackService} from '@/core/api-feedback.service';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  private readonly fallbackMessage = 'Lo sentimos. Hubo un problema. Inténtalo de nuevo más tarde';
  private readonly networkErrorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión e inténtalo de nuevo';

  constructor(private feedback: ApiFeedbackService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.apiBase)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((err: unknown) => {
        const payload = this.extractErrorPayload(err, this.fallbackMessage);
        this.feedback.showError(payload);
        return throwError(() => err);
      })
    );
  }

  private extractErrorPayload(err: unknown, fallback: string): unknown {
    if (!(err instanceof HttpErrorResponse)) {
      return fallback;
    }

    if (err.status === 0) {
      return this.networkErrorMessage;
    }

    const payload = err.error as unknown;
    if (payload != null) {
      return payload;
    }

    if (typeof err.message === 'string' && err.message.trim().length > 0) {
      return err.message.trim();
    }

    return fallback;
  }
}
